import { render, staticRenderFns } from "./PollFrequency.vue?vue&type=template&id=453da428&scoped=true&"
import script from "./PollFrequency.vue?vue&type=script&lang=ts&"
export * from "./PollFrequency.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "453da428",
  null
  
)

export default component.exports